import Vue from './app.js';
import { router } from './app.js';

export default {
    user: {
        authenticated: false,
        profile: null,
        notifications: null
    },
    check(context) {
        let token = localStorage.getItem('id_token')
        if (token !== null) {
            Vue.http.get(
                'api/user?token=' + token
            ).then(response => {
                this.user.authenticated = true
                this.user.profile = response.data.data
                Vue.http.post(
                    'api/notification/show', {
                        users_id: response.data.data.id,
                    }
                ).then(response => {
                    this.user.notifications = response.data.data
                    this.totalNotif = response.data.totalNotif
                }).then(response => {
                    $('body').removeClass('loading')
                })
            }, error => {
                localStorage.removeItem('id_token')
                localStorage.removeItem('id_user')
                localStorage.removeItem('type_user')
                this.user.authenticated = false
                this.user.profile = null
                router.push({
                    name: 'signin'
                })
            })
            return true
        }else{
            return false
        }
    },
    notifications() {
        Vue.http.post(
            'api/notification/show', {
                users_id: this.user.profile.id,
            }
        ).then(response => {
            this.user.notifications = response.data.data;
            this.totalNotif = response.data.totalNotif;
            $('body').removeClass('loading')
        })
    },
    register(context, name, email, password) {
        Vue.http.post(
            'api/register', {
                name: name,
                email: email,
                password: password
            }
        ).then(response => {
            context.success = true
        }, response => {
            context.response = response.data
            context.error = true
        })
    },
    signin(context, email, password) {
        console.log(context, email, password);
        Vue.http.post(
            'api/signin', {
                email: email,
                password: password
            }
        ).then(response => {
            context.error = false
            localStorage.setItem('id_token', response.data.meta.token)
            localStorage.setItem('id_user', response.data.data.id)
            localStorage.setItem('type_user', response.data.data.type)
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token')
            this.user.authenticated = true
            this.user.profile = response.data.data
            router.push({
                name: 'Reporting'
            })
        }, response => {
            context.error = true
        })
    },
    signout() {
        localStorage.removeItem('id_token')
        localStorage.removeItem('id_user')
        localStorage.removeItem('type_user')
        this.user.authenticated = false
        this.user.profile = null
        router.push({
            name: 'signin'
        })
    },
    createNotification(context, name, users_id) {
        Vue.http.post(
            'api/notification/new', {
                name: name,
                users_id: users_id,
                notification_id: notification_id
            }
        ).then(response => {
            console.log(response.data)
                //    context.response = response.data;
                // if (context.response.error) {
                //  context.showError();
                // }
                // else {
                //  context.clients();
                //  context.showSuccessCreate();
                // }
        })
    },
    destroyNotification(context, id) {
        Vue.http.post(
            '/api/notification/delete', {
                id: id
            }
        ).then(response => {
            context.response = response.data
            if (context.response.error) {
                console.log(response.data)
                    // context.showError();
            } else {
                context.notifications();
                context.showSuccessDelete();
            }
        })
    }
}



// WEBPACK FOOTER //
// ./assets/js/auth.js